import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import AutoSuggest from "./autosuggest-lib";
import * as S from "./autosuggest.styles";
import { cabsAutoComplete, SOURCE_TYPE } from "../../config/constants";
import HomeAutoSuggestCard from "../../../stories/components/cars/homepage/AutoSuggest/AutosuggestCard";
import HomeAutoSuggest from "../../../stories/components/cars/homepage/AutoSuggest/AutoSuggestUI";
import { getGeoLocation, getRecentSearches } from "../../config/utils";
import { getCurrentLocationApi, getPlaceDetails } from "../../common/redux/thunks";
import useOutsideClick from "../../hooks/useOutsideClick";
import { gcBookingReviewScreen, gcHomeScreen, gcTripCategoryScreen, getLoadedComponent, pushCtaOmniEvents } from "../../config/omni";
import { setter } from '../../utils/storage';
import { CTA_TYPE, getActionNameForOmniture } from "../../utils/omni-utils";
import { AUTOSUGGEST, AUTOSUGGEST_CURRENT_LOCATION, AUTOSUGGEST_DROP_LOCATION, AUTOSUGGEST_PAGE, AUTOSUGGEST_PICKUP_LOCATION, CABS_LANDING_ROUTE, CABS_LISTING_ROUTE, CABS_REVIEW_ROUTE } from "../../utils/util-constants";
import { destinationSelector, multicityStopOversSelector, previousDestinationSelector, previousMulticityStopOversSelector, previousSourceSelector, sourceSelector } from "../../common/redux/selector";
import { UPDATE_MULTICITY_STOPOVERS, UPDATE_PREVIOUS_MULTICITY_STOPOVERS } from "../../pages/SearchPage/redux/action-types";
import { UPDATE_DESTINATION, UPDATE_PREVIOUS_DESTINATION, UPDATE_PREVIOUS_SOURCE, UPDATE_SOURCE } from "../../common/redux/action-types";

interface AutoSuggestProps {
  label: string;
  labelVal: string;
  toggleOverlay: (boolean) => {};
  widget: any;
  title: string;
  type: string;
  popularSearch: Array<{}>;
  top: string;
  onSuggestUpdate: Function;
  autoFocus: boolean;
  placeVal?: string
  invokedFor ?: string
  width ?: string
  id ?: number
}

const AutoSuggestWrapper: React.FC<AutoSuggestProps> = ({
  label = "source",
  labelVal = "From",
  title = "",
  type = "ow",
  popularSearch = [],
  top = '',
  onSuggestUpdate = () => { },
  autoFocus = false,
  invokedFor = "",
  placeVal = "",
  width = "",
  id,
  widget = ({
    autosuggestRef,
    props,
    inputRef,
    label,
    setInitialPage,
    onShowInitialPage,
    handleKeyBoard,
    id,
    autoFocus = false
  }) => {
    const dispatch = useDispatch()
    const source = useSelector(sourceSelector);
    const destination = useSelector(destinationSelector);
    const prevSource = useSelector(previousSourceSelector);
    const prevDestination = useSelector(previousDestinationSelector);
    const store = useStore()

    return (
      <S.InputText
        ref={autosuggestRef}
        className={onShowInitialPage ? "active" : ""}
        onClick={() => {
          setInitialPage(true);
          if (label?.toLowerCase()?.includes('stop')) {
            setTimeout(() => {
              const stopOvers = store.getState()?.common?.stopOvers ? store.getState()?.common?.stopOvers : []
              const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
              const index = newStopOvers.findIndex((item) => item?.id === id)
              if (index > -1 && newStopOvers[index]?.value?.name) {
                newStopOvers[index].value = {}
              }
              dispatch({
                type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
                previousStopOvers: stopOvers
              })
              dispatch({
                type: UPDATE_MULTICITY_STOPOVERS,
                stopOvers: newStopOvers
              })
            }, 1)
          } else {
            const key = label === "source" ? "previousSource" : "previousDestination"
            setTimeout(() => {
              dispatch({
                type: label === "source" ? UPDATE_PREVIOUS_SOURCE : UPDATE_PREVIOUS_DESTINATION,
                [key]: label === "source" ? source : destination,
              })
              dispatch({
                type: label === "source" ? UPDATE_SOURCE : UPDATE_DESTINATION,
                [label]: {},
              });
    
              if ((label === "source" && !destination?.name) || label === "destination" && !source?.name) {
                const key = label === "source" ? "destination" : "source"
                dispatch({
                  type: label === "source" ? UPDATE_DESTINATION : UPDATE_SOURCE,
                  [key]: label === "source" ? prevDestination : prevSource
                });
              }
            }, 1)
          }
        }}
      >
        <label>{labelVal}</label>
        <input {...props} ref={inputRef} autoFocus={onShowInitialPage || autoFocus} onKeyDown={handleKeyBoard} style={{textOverflow: "ellipsis"}} />
      </S.InputText>
    );
  },
}) => {
  const autosuggestRef = React.createRef();
  const dispatch = useDispatch();
  const store = useStore();
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const prevSource = useSelector(previousSourceSelector);
  const prevDestination = useSelector(previousDestinationSelector);
  const stopOvers = useSelector(multicityStopOversSelector);
  const previousStopOvers = useSelector(previousMulticityStopOversSelector);
  const inputRef = useRef(null);
  const [onShowInitialPage, setInitialPage] = useState(false);
  const [cursorResult, setCursorResult] = useState(-1)
  const [stopCursorUpdate, setStopCursorUpdate] = useState(false)
  const [onEnterPress, setOnEnterPress] = useState(false)
  const getUrl = (input, rf) => {
    const state = store.getState();
    const {srp ={}} = state
    const {os_destination_lat_long, os_source_lat_long, airport_destination_lat_long, airport_source_lat_long} = srp
    const url = `${__ENV_CONFIG__["__GOCARS__"]}/${cabsAutoComplete}`;

    let params = {
      input: input,
      limit: 10,
      media: "source",
      rf: rf,
      vertical: "GoCars",
      flavour: "cars_dweb",
      flow_name: "QuickBook"
    }
    if (invokedFor === gcTripCategoryScreen) {
      const source_lat_long = rf === "at" ? airport_source_lat_long : os_source_lat_long
      const destination_lat_log = rf === "at" ? airport_destination_lat_long : os_destination_lat_long
      const lat_long = label === "source" ? source_lat_long : destination_lat_log
  
      if (lat_long && Object.keys(lat_long)?.length) {
        params["location"] = lat_long
      }
    }
  
    if (invokedFor === gcBookingReviewScreen) {
      params["ohl"] = "yes"
      const source_lat_long = rf === "at" ? airport_source_lat_long : os_source_lat_long
      if (source_lat_long && Object.keys(source_lat_long)?.length) {
        params["location"] = source_lat_long
      }
    }

    const headers = new Headers({
      Authorization: "Basic Zm9vOmJhcg==",
      "Content-Type": "application/json"
    })

    const request = new Request(url, {
      headers,
      credentials: 'include',
      method: "POST",
      body: JSON.stringify(params)
    });

    return request;
  };

  useEffect(() => {
    if (cursorResult === -1 && stopCursorUpdate) setStopCursorUpdate(false)
  }, [cursorResult])

  const handleKeyBoard = (e) => {
    if (e.keyCode === 38 && cursorResult > 0) {
      setCursorResult(prevState => prevState - 1)
      if (stopCursorUpdate) {
        setStopCursorUpdate(!stopCursorUpdate)
      }
    } 
    
    if (e.keyCode === 40 && !stopCursorUpdate) {
      setCursorResult(prevState => prevState + 1)
    }

    if (e.keyCode === 13 && cursorResult >= 0) {
      setOnEnterPress(true)
    }
  }

  useOutsideClick(autosuggestRef, () => {
    setInitialPage(false);
    if (label?.toLowerCase()?.includes('stop')) {
      const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
      const prevStopOvers = JSON.parse(JSON.stringify(previousStopOvers))
      const newStopIndex = newStopOvers.findIndex((item) => item?.id === id)
      const previousStopIndex = previousStopOvers.findIndex((item) => item?.id === id)
      if (newStopIndex > -1 && previousStopIndex > -1 && prevStopOvers[previousStopIndex]?.value?.name && !newStopOvers[newStopIndex]?.value?.name) {
        dispatch({
          type: UPDATE_MULTICITY_STOPOVERS,
          stopOvers: prevStopOvers
        })
      }
    }
    if (!destination?.name) {
      dispatch({
        type: UPDATE_DESTINATION,
        destination: prevDestination 
      });
    }

    if (!source?.name) {
      dispatch({
        type: UPDATE_SOURCE,
        source: prevSource
      });
    }
  });

  const getPageNameForOmniture = useCallback(
    () => {
    let destinationName = ""

    switch (invokedFor) {

      case gcHomeScreen :
        destinationName = CABS_LANDING_ROUTE
        break

      case gcTripCategoryScreen : 
        destinationName = CABS_LISTING_ROUTE
        break

      case gcBookingReviewScreen :
        destinationName = CABS_REVIEW_ROUTE
        break

      default :
        destinationName = CABS_LANDING_ROUTE
    }

    return destinationName
  }, [])

  const onCurrentLocation = useCallback(() => {
    const onsuccess = async (position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      const item = await getCurrentLocationApi({ latitude, longitude });
      const {
        Description: name,
        Place_id: place_id = "",
        LocType: loc_type = "",
        Region: city_name = "",
        lobCity = city_name || "",
        lat = "",
        lng = "",
        locus = {}
      } = item;
      const resp = { name, place_id, loc_type, city_name, lobCity, lat, lng, locus };
      const placeDetailsResp = await getPlaceDetails(place_id)
      if (label === "source") {
        const types = resp?.types
        setter(SOURCE_TYPE, types)
      }
      if (invokedFor?.length) {
        const destinationName = getPageNameForOmniture()
        pushCtaOmniEvents(getActionNameForOmniture(invokedFor, AUTOSUGGEST_CURRENT_LOCATION), CTA_TYPE.HYPER_LINK, AUTOSUGGEST_PAGE, destinationName)
      }

      const respDetails = {
        ...resp,
        ...placeDetailsResp
      }

      dispatch({
        type: label === "source" ? UPDATE_SOURCE : UPDATE_DESTINATION,
        [label]: respDetails,
      });

    };
    getGeoLocation(onsuccess);
    setOnEnterPress(false)
  }, []);

  useEffect(() => {
    getLoadedComponent('AutoSuggestWrapper')
    inputRef?.current?.blur();
  }, []);

  const massageData = (item) => item;
  const itemToString = (item) => item?.description;
  const onSourceSelect = async (item) => {
    setInitialPage(false);
    const {
      description: name,
      place_id = "",
      loc_type = "",
      region: city_name = "",
      types = [],
      lobCity = city_name || "",
      lat = "",
      lng = "",
      state = "",
      locus = {}
    } = item;
    const resp = { name, place_id, loc_type, city_name, types, lobCity, lat, lng, locus, state };
    const placeDetailsResp = await getPlaceDetails(place_id)
    if (label === "source") {
      const types = resp?.types
      setter(SOURCE_TYPE, types)
    }
    
    const destinationName = getPageNameForOmniture()
    if (label?.toLowerCase()?.includes('stop')) {
      const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
      const index = newStopOvers.findIndex((item) => item?.id === id)
      if (index > -1) {
        newStopOvers[index].value = {
          name : item?.name ? item?.name : resp?.name, 
          place_id : item?.place_id ? item?.place_id : resp?.place_id, 
          city_name : item?.city_name ? item?.city_name : resp?.city_name,
          ...placeDetailsResp
        }
      }
      pushCtaOmniEvents(getActionNameForOmniture(invokedFor, `${AUTOSUGGEST}_${label.replace(' ', '_')}`), CTA_TYPE.HYPER_LINK, AUTOSUGGEST_PAGE, destinationName)
      dispatch({
        type: "UPDATE_MULTICITY_STOPOVERS",
        stopOvers: newStopOvers
      })
    } else {
      if (invokedFor?.length) {
        pushCtaOmniEvents(getActionNameForOmniture(invokedFor, label === "source" ? AUTOSUGGEST_PICKUP_LOCATION : AUTOSUGGEST_DROP_LOCATION), CTA_TYPE.HYPER_LINK, AUTOSUGGEST_PAGE, destinationName)
      }
      const respDetails = {
        ...(item?.name ? item : resp),
        ...placeDetailsResp
      }
      dispatch({
        type: label === "source" ? UPDATE_SOURCE : UPDATE_DESTINATION,
        [label]: respDetails,
      });
    }

    if (onSuggestUpdate) onSuggestUpdate(label, item);

    setOnEnterPress(false)
  };

  const onInputValueChange = (e) => {};
  const inputElement = React.forwardRef((props, ref) => {
    return widget({
      autosuggestRef,
      props,
      inputRef,
      label,
      setInitialPage,
      onShowInitialPage,
      type,
      autoFocus,
      id,
      handleKeyBoard
    });
  });

  const List = (props) => {
    return <S.AutoSuggest top={top}>{props.children}</S.AutoSuggest>;
  };

  const itemElement = useCallback(
    (item) => {
      let iconName = 'LocationIcon';
      switch (item.loc_type) {
        case 'airport':
          iconName = 'AirportIcon';
          break;
        case 'city':
          iconName = 'BuildingIcon';
          break;
        default:
          break;
      }
      return (
        <HomeAutoSuggestCard title={item?.description} subTitle={item?.region} iconName={iconName} />
      )
    },
    []
  );
  const placeholder = label === "source" ? 'Enter Pickup location' : 'Enter Drop location';
  const onInitialPlaceHolder = label === "source" ? 'Enter Pickup location (Area, street or landmark)' : 'Enter Drop location (Area, street or landmark)';
  return (
    <AutoSuggest
      placeholder={placeVal?.length ? placeVal : onShowInitialPage ? onInitialPlaceHolder : placeholder}
      getUrl={getUrl}
      initialInputValue={title}
      massageData={massageData}
      onItemSelection={onSourceSelect}
      itemToString={itemToString}
      itemElement={itemElement}
      Input={inputElement}
      onInputValueChange={onInputValueChange}
      resetOnInputBlur={false}
      onShowInitialPage={onShowInitialPage}
      List={List}
      rf={type}
      width={width}
      cursor={cursorResult}
      setStopCursorUpdate={setStopCursorUpdate}
      setCursorResult={setCursorResult}
      onEnterPress={onEnterPress}
      renerInitailView={
        onShowInitialPage ? (
          <HomeAutoSuggest
            isSouce={!!(label === "source")}
            currenLocation={onCurrentLocation}
            recentSearch={getRecentSearches({type})}
            popularLocation={popularSearch}
            onSourceSelect={onSourceSelect}
            cursor={cursorResult}
            onEnterPress={onEnterPress}
            setStopCursorUpdate={setStopCursorUpdate}
          />
        ) : (
          <></>
        )
      }
    />
  );
};

export default React.memo(AutoSuggestWrapper);
